/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'rollback': {
    width: 23,
    height: 23,
    viewBox: '0 0 23 23',
    data: '<path pid="0" d="M11.5 2.5a9 9 0 110 18 9 9 0 010-18zm0 1.5a7.5 7.5 0 100 15 7.5 7.5 0 000-15zm-2 5.5l-1.015-.846a4.52 4.52 0 005.144 7.066l.531 1.378a6.001 6.001 0 01-8.026-6.859c.2-.934.621-1.8 1.217-2.53L6.5 7l3-.5v3zm1.774-3.4c.373 0 .675.302.675.674v5.07l3.45 1.931a.675.675 0 01-.66 1.178l-3.795-2.125-.344-.193v-5.86c0-.373.302-.675.674-.675z" _fill="currentColor"/>'
  }
})
